/**
=========================================================
* Material Dashboard 2 React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/
import { Link } from "react-router-dom";
// prop-types is library for typechecking of props
import PropTypes from "prop-types";

// @mui material components
import { Grid, Card, Divider, Icon } from "@mui/material";

// Material Dashboard 2 React components
import MDBox from "dashboard/components/MDBox";
import MDTypography from "dashboard/components/MDTypography";
import MDButton from "dashboard/components/MDButton";


function InfoCard({ id, color, image, title, telephone, mobile, email, website, address, province, location, handleDistributorClick, sendForm = false , distributorId = null, info = null}) {
  return (
    <Card sx={{mb:1.5}} >
      <Grid container p={{xs:.5, lg:1}} mx={{xs:0, lg:2}} alignItems="center" justifyContent="flex-between">
        <Grid sx={{minWidth:{xs:"33%",lg:"16.66%"}}} item xs={4} lg={2}>
          <MDBox
              component="img"
              src={image}
              alt={title}
              borderRadius="lg"
              width="100%"
              position="relative"
              zIndex={1}
              onError={({ currentTarget }) => {
                /*eslint-disable*/
                currentTarget.onerror = null; // prevents looping
                currentTarget.src=`${process.env.REACT_APP_PUBLIC_URL}/img/user-default.png`;
              }}
              sx={{cursor:"pointer"}} 
          />
        </Grid>
        <Grid item xs={8} lg={9}>
        <MDBox sx={{mx:1}}>
            <MDTypography variant="h5" fontWeight="medium" color="primary" textTransform="capitalize">
                {title}
            </MDTypography>
              <Grid container spacing={.5}>
                <Grid item xs={12} lg={6} >
                  <MDTypography variant="body2" >
                    <Icon sx={{color : "#277cbb", mx :1}}>phone</Icon>
                    {telephone}
                  </MDTypography>
                </Grid>
                <Grid item xs={12} lg={6} >
                <MDTypography variant="body2" >
                    <Icon sx={{color : "#277cbb", mx :1}}>email</Icon>
                    {email}
                  </MDTypography>
                </Grid>
                <Grid item xs={12} lg={6} >
                <MDTypography variant="body2" >
                    <Icon sx={{color : "#277cbb", mx :1}}>phone_iphone</Icon>
                    {mobile}
                  </MDTypography>
                </Grid>
                <Grid item xs={12} lg={6} >
                <MDTypography variant="body2" >
                    <Icon sx={{color : "#277cbb", mx :1}}>phone</Icon>
                    {website}
                  </MDTypography>
                </Grid>
              </Grid>
              <MDTypography variant="caption" >
                <Icon sx={{color : "primary.main", mx :1}}>location_on</Icon>
                {address}
              </MDTypography>
              <MDTypography variant="caption" >
                <Icon sx={{color : "primary.main", mx :1}}>signpost</Icon>
                {province}
              </MDTypography>
            </MDBox>
          
        </Grid>
      </Grid>
      <MDBox pb={1} px={{xs:0.2, lg :1}}  >
        <Divider sx={{my:0,mb:1}}/>
        <Grid container justifyContent="flex-end">
          {info !== null && <Grid sx={{display:"flex", alignItems:"center"}} item xs={2.5} lg={1.5}><Icon sx={{color : "primary.main", mx :.5}}>train</Icon> 
            <MDTypography fontWeight="medium" variant="caption">{info.distance} km</MDTypography>
          </Grid>}
          {info !== null && <Grid sx={{display:"flex", alignItems:"center"}} item xs={2.5} lg={1.5}><Icon sx={{color : "primary.main", mx :.5}}>inventory_2</Icon> 
            <MDTypography variant="caption" fontWeight="medium">{info.matching_products} <MDTypography variant="caption" sx={{display:{xs:"none", lg:"inline"}}}> produits</MDTypography></MDTypography> 
          </Grid>}
          <Grid item xs={7} lg={9} sx={{textAlign:'right'}}>       
            {sendForm ?
              <MDButton  color={distributorId === id ? "success" :"info"} variant="gradient" sx={{mx:1, px : {xs:1, lg:2}}} onClick={handleDistributorClick}>{distributorId === id ?<Icon>checked</Icon> : null} {distributorId === id ? "choisie" :  "choisir"}</MDButton>
            :
              <MDButton color="primary" variant="gradient" sx={{mx:1,px : {xs:1, lg:2}}} onClick={()=>handleDistributorClick(location)} >localisation</MDButton>}
            <MDButton sx={{px : {xs:1, lg:2}}} color={color} variant="gradient" component={Link} to={`/distributors/${id}`}>page</MDButton>
          </Grid>
        </Grid>
      </MDBox>
    </Card>
  );
}

// Setting default addresss for the props of DefaultInfoCard
InfoCard.defaultProps = {
  color: "info",
  address: "",
  description: "",
};

// Typechecking props for the DefaultInfoCard
InfoCard.propTypes = {
  color: PropTypes.oneOf(["primary", "secondary", "info", "success", "warning", "error", "dark"]),
  image: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  description: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  address: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default InfoCard;
